//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { Enums } from '../common/enums'

import { CommonHelper } from '../../helpers/common-helper'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { TypeHelper } from '../../helpers/type-helper'

import { OpDataTypeClass } from './op-data-type-class'
import { OpDataTypeFormat } from './op-data-type-format'
import { OpReferenceType } from './op-reference-type'
import { OpUnit } from './op-unit'
import { OpDescr } from './op-descr'

import { IReferenceType, IOpChangeState, IJsonSerializable, ICopyable } from '../util/interfaces'

export class OpDataType implements IReferenceType, IOpChangeState, IJsonSerializable, ICopyable<OpDataType> {

    // #region Properties

    public idDataType: number
    public idDataTypeClass: number
    public idDataTypeFormat: number
    public idReferenceType: number
    public idUnit: number
    public isEditable: boolean
    public name: string
    public idDescr: number

    // #endregion


    // #region NavigationProperties

    public dataTypeClass: OpDataTypeClass
    public dataTypeFormat: OpDataTypeFormat
    public referenceType: OpReferenceType
    public unit: OpUnit
    public descr: OpDescr

    // #endregion


    // #region CustomProperties

    public defaultValue: any

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpDataType) {
            this.copy(<OpDataType>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion


    // #region IOpChangeState

    public opState: Enums.OpChangeState

    // #endregion


    // #region IReferenceType

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDataType
    }
    public getReferenceKey(): number {
        return this.idDataType
    }
    public getReferenceValue(): any {
        return this
    }

    // #endregion

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDataType[]): JQueryPromise<OpDataType[]> {
        var defered = $.Deferred<OpDataType[]>()
        if (dataProvider && list && list.length > 0) {
            var idDataTypeClass: number[] = CommonHelper.distinct<number>(list.map(d => d.idDataTypeClass))
            var idUnit: number[] = CommonHelper.distinct<number>(list.map(d => d.idUnit))
            var idDataTypeFormat: number[] = CommonHelper.distinct<number>(list.map(d => d.idDataTypeFormat))
            var idReferenceType: number[] = CommonHelper.distinct<number>(list.map(d => d.idReferenceType))
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataTypeClass, Enums.ReferenceType.IdDataTypeFormat, Enums.ReferenceType.IdReferenceType, Enums.ReferenceType.IdUnit]).then(dict => {
                var dataTypeClassDict: Dictionary<OpDataTypeClass> = new Dictionary<OpDataTypeClass>(null)
                var dataTypeFormatDict: Dictionary<OpDataTypeFormat> = new Dictionary<OpDataTypeFormat>(null)
                var referenceTypeDict: Dictionary<OpReferenceType> = new Dictionary<OpReferenceType>(null)
                var unitDict: Dictionary<OpUnit> = new Dictionary<OpUnit>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataTypeClass)) {
                    dataTypeClassDict = <Dictionary<OpDataTypeClass>>dict.tryGetValue(Enums.ReferenceType.IdDataTypeClass)
                }
                if (dict.containsKey(Enums.ReferenceType.IdDataTypeFormat)) {
                    dataTypeFormatDict = <Dictionary<OpDataTypeFormat>>dict.tryGetValue(Enums.ReferenceType.IdDataTypeFormat)
                }
                if (dict.containsKey(Enums.ReferenceType.IdReferenceType)) {
                    referenceTypeDict = <Dictionary<OpReferenceType>>dict.tryGetValue(Enums.ReferenceType.IdReferenceType)
                }
                if (dict.containsKey(Enums.ReferenceType.IdUnit)) {
                    unitDict = <Dictionary<OpUnit>>dict.tryGetValue(Enums.ReferenceType.IdUnit)
                }

                list.forEach(item => {
                    item.dataTypeClass = dataTypeClassDict.tryGetValue(item.idDataTypeClass)
                    item.dataTypeFormat = dataTypeFormatDict.tryGetValue(item.idDataTypeFormat)
                    item.referenceType = referenceTypeDict.tryGetValue(item.idReferenceType)
                    item.unit = unitDict.tryGetValue(item.idUnit)
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }
        return defered.promise()
    }

    // #region IJsonSerializable

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idDataType = opObj.I
                this.idDataTypeClass = opObj.IC
                this.idDataTypeFormat = opObj.IF
                this.idDescr = opObj.ID
                this.idReferenceType = opObj.IR
                this.idUnit = opObj.IU

                this.isEditable = opObj.IE
                this.name = opObj.N
                this.defaultValue = opObj.DV

                this.opState = opObj.O

                this.descr = opObj.D ? new OpDescr(opObj.D) : null
            }
            else {
                this.idDataType = opObj.ID_DATA_TYPE
                this.idDataTypeClass = opObj.ID_DATA_TYPE_CLASS
                this.idDataTypeFormat = opObj.ID_DATA_TYPE_FORMAT
                this.idDescr = opObj.ID_DESCR
                this.idReferenceType = opObj.ID_REFERENCE_TYPE
                this.idUnit = opObj.ID_UNIT

                this.defaultValue = opObj.DefaultValue
                this.isEditable = opObj.IS_EDITABLE
                this.name = opObj.NAME

                this.opState = opObj.OpState

                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.dataTypeClass = opObj._DataTypeClass ? new OpDataTypeClass(opObj._DataTypeClass) : null
                this.dataTypeFormat = opObj._DataTypeFormat ? new OpDataTypeFormat(opObj._DataTypeFormat) : null
                this.referenceType = opObj._ReferenceType ? new OpReferenceType(opObj._ReferenceType) : null
                this.unit = opObj._Unit ? new OpUnit(opObj._Unit) : null
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const compressedObj: any = {
                I: this.idDataType,
                IC: this.idDataTypeClass,
                IF: this.idDataTypeFormat,
                ID: this.idDescr,
                IR: this.idReferenceType,
                IU: this.idUnit,

                DV: this.defaultValue,
                IE: this.isEditable,
                N: this.name,

                D: this.descr ? this.descr.toJSON(compressed) : null,

                O: this.opState,

                __IC: 1
            }

            TypeHelper.deleteNulls(compressedObj)

            return compressedObj
        }
        else {
            return {
                ID_DATA_TYPE: this.idDataType,
                ID_DATA_TYPE_CLASS: this.idDataTypeClass,
                ID_DATA_TYPE_FORMAT: this.idDataTypeFormat,
                ID_REFERENCE_TYPE: this.idReferenceType,
                ID_UNIT: this.idUnit,
                ID_DESCR: this.idDescr,

                DefaultValue: this.defaultValue,
                IS_EDITABLE: this.isEditable,
                NAME: this.name,

                _Descr: this.descr ? this.descr.toJSON(compressed) : null,

                OpState: this.opState
            }
        }
    }

    // #endregion

    public toString() {
        if (this.descr)
            return this.descr.toString()
        else
            return this.name
    }

    public static restore(restoredOpObj: OpDataType) {
        if (restoredOpObj) {
            var opObj = new OpDataType()
            opObj.idDataType = restoredOpObj.idDataType
            opObj.idDataTypeClass = restoredOpObj.idDataTypeClass
            opObj.idDataTypeFormat = restoredOpObj.idDataTypeFormat
            opObj.idReferenceType = restoredOpObj.idReferenceType
            opObj.idUnit = restoredOpObj.idUnit
            opObj.isEditable = restoredOpObj.isEditable
            opObj.name = restoredOpObj.name
            opObj.idDescr = restoredOpObj.idDescr
            opObj.opState = restoredOpObj.opState

            opObj.descr = OpDescr.restore(restoredOpObj.descr)
            opObj.dataTypeClass = OpDataTypeClass.restore(restoredOpObj.dataTypeClass)
            opObj.dataTypeFormat = OpDataTypeFormat.restore(restoredOpObj.dataTypeFormat)
            opObj.referenceType = OpReferenceType.restore(restoredOpObj.referenceType)
            opObj.unit = OpUnit.restore(restoredOpObj.unit)

            opObj.defaultValue = restoredOpObj.defaultValue
            return opObj
        }
        return null
    }

    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): OpDataType {

        const dataType: OpDataType = new OpDataType(null)

        dataType.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return dataType
    }

    public copy(source: OpDataType, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {
        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.dataTypeClass = source.dataTypeClass
            this.dataTypeFormat = source.dataTypeFormat
            this.referenceType = source.referenceType
            this.unit = source.unit
            this.descr = source.descr
        }

        if (source.dataTypeClass != null) {
            this.dataTypeClass = source.dataTypeClass
        }

        if (source.dataTypeFormat != null) {
            this.dataTypeFormat = source.dataTypeFormat
        }

        if (source.referenceType != null) {
            this.referenceType = source.referenceType
        }

        if (source.unit != null) {
            this.unit = source.unit
        }

        if (source.descr != null) {
            this.descr = source.descr
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idDataType = source.idDataType
        this.idDataTypeClass = source.idDataTypeClass
        this.idDataTypeFormat = source.idDataTypeFormat
        this.idReferenceType = source.idReferenceType
        this.idUnit = source.idUnit
        this.isEditable = source.isEditable
        this.name = source.name
        this.idDescr = source.idDescr
        this.opState = source.opState

    }

    // #endregion
}